import React from "react"
import { Testimonial, TestimonialProps } from "../components/blocks/testimonial"
import { Process, ProcessProps } from "../components/blocks/process"
import { Typeform, TypeformProps } from "../components/blocks/typeform"
import { Experts, ExpertsProps } from "../components/blocks/experts"
import { SingleExpert, SingleExpertProps } from "../components/blocks/singleexpert"
import { ValuePropositions, VpProps } from "../components/blocks/vp"
import { FreeContentProps, FreeContent } from "../components/blocks/freecontent"
import { TeamSectionProps, TeamSection } from "./blocks/team"
import { PageMarkdownSectionProps, PageMarkdownSection } from "./blocks/pagemdsection"
import { LeadFormSectionProps, LeadForm } from "./blocks/leadform"
import { ImageSection, ImageSectionProps } from "./blocks/imagesection"

interface BlockMap {
    testimonials: React.FC<TestimonialProps>
    process: React.FC<ProcessProps>
    typeform: React.FC<TypeformProps>
    experts: React.FC<ExpertsProps>
    "single-expert": React.FC<SingleExpertProps>
    propositions: React.FC<VpProps>
    "free-content": React.FC<FreeContentProps>
    "team-section": React.FC<TeamSectionProps>
    "page-md-content": React.FC<PageMarkdownSectionProps>
    "lead-form": React.FC<LeadFormSectionProps>
    "image-section": React.FC<ImageSectionProps>
}

export type PageBlockProps = Omit<
    TestimonialProps | ProcessProps | TypeformProps | ExpertsProps | SingleExpertProps | VpProps | FreeContentProps,
    "color"
>

interface Props extends React.HTMLAttributes<HTMLElement> {
    blocks: Array<PageBlockProps>
    backgroundColor?: "white" | "light-blue"
}

const Blocks = ({ blocks, backgroundColor }: Props): JSX.Element => {
    const BLOCKS_MAP: BlockMap = {
        testimonials: Testimonial,
        process: Process,
        typeform: Typeform,
        experts: Experts,
        "single-expert": SingleExpert,
        propositions: ValuePropositions,
        "free-content": FreeContent,
        "team-section": TeamSection,
        "page-md-content": PageMarkdownSection,
        "lead-form": LeadForm,
        "image-section": ImageSection,
    }

    return (
        <>
            {blocks.map((block, i) => {
                // prevent from rendering unhandled block
                const { template, ...rest } = block
                if (template in BLOCKS_MAP) {
                    const Block: React.FC<any> = BLOCKS_MAP[template]
                    const key = `block_${template}_${i}`
                    return (
                        <div key={key}>
                            <Block color={backgroundColor || i % 2 ? "white" : "light-blue"} {...rest} />
                        </div>
                    )
                }
                return null
            })}
        </>
    )
}

export { Blocks }
